import React, { FC } from 'react';
import { useTranslate, required } from 'react-admin';
import { Grid, TableCell } from '@material-ui/core';

import { StatusField } from '~/components';
import AccountTableMultiselect from './AccountTableMultiselect/AccountTableMultiselect';
import { Terminal } from '~/types';

interface SelectAccountProps {
  resource: 'businesses';
  solutionId: string;
  profileId: string;
  source?: string;
  businessId: string;
  terminalRecord?: Terminal;
}

const AccounsSelectModal: FC<SelectAccountProps> = (props) => {
  const { resource, profileId, source, businessId, solutionId, terminalRecord } = props;

  const translate = useTranslate();
  const t = (key: string): string => translate(`resources.businesses.terminals.${key}`); // TODO ${resource}

  return (
    <AccountTableMultiselect
      solutionId={solutionId}
      resource={resource}
      profileId={profileId}
      businessId={businessId}
      label={t('accounts')}
      validate={required()}
      source={source || 'accountIds'}
      optionText='number'
      fullWidth
      title={t('selectAccounts')}
      warning={t('selectAccountsWarning')}
      filters={['status', 'number', 'alias', 'currency']}
      tableProps={{
        headers: [t('accountNumber'), t('accountAlias'), t('currency')],
        renderRow: (item) => (
          <>
            <TableCell>
              <Grid container spacing={1} alignItems='center' wrap='nowrap'>
                <Grid item>
                  <StatusField status={item.status} variant='dot' />
                </Grid>
                <Grid item>{item.number}</Grid>
              </Grid>
            </TableCell>
            <TableCell>{item.alias}</TableCell>
            <TableCell>{item.currency}</TableCell>
          </>
        ),
      }}
      terminalRecord={terminalRecord}
    />
  );
};

export default AccounsSelectModal;
